import { ReactNode, CSSProperties } from 'react';

interface TiCardProps {
  /** Optional section-label header text */
  label?: string;
  /** Optional custom header (replaces label) */
  header?: ReactNode;
  /** Main card content */
  children: ReactNode;
  /** Optional footer content rendered below children */
  footer?: ReactNode;
  /** Apply fade-in animation (for expandable cards) */
  animate?: boolean;
  /** Fill parent height */
  fullHeight?: boolean;
  /** Additional inline styles */
  style?: CSSProperties;
  /** Additional CSS class */
  className?: string;
}

export default function TiCard({
  label,
  header,
  children,
  footer,
  animate = false,
  fullHeight = false,
  style,
  className,
}: TiCardProps) {
  const classes = [
    'ti-card',
    animate ? 'fade-in' : '',
    className || '',
  ].filter(Boolean).join(' ');

  const cardStyle: CSSProperties = {
    ...(fullHeight ? { height: '100%' } : {}),
    ...style,
  };

  return (
    <div className={classes} style={cardStyle}>
      {header}
      {!header && label && <div className="section-label">{label}</div>}
      {children}
      {footer}
    </div>
  );
}
